import NoUiSlider from './NoUiSlider';
export default NoUiSlider;
